import Protected from '../components/protected';

const ProtectedPage = () => {
  return (
      <Protected />
  );
};

export default ProtectedPage;
